<template>
  <div class="news-container">
    <module1 />
    <module2  ref="newsTable" />
  </div>
</template>

<script>
import module1 from "./module1.vue";
import module2 from "./module2.vue";
import {EventBus} from "@/utils/bus";

export default {
    name: "NewsPage",
    components: {
      module1,
      module2,
    },
    methods:{

    },mounted() {

    }
};
</script>

<style scoped>
.news-container {
  display: flex;
  flex-direction: column;
}
</style>